/* SendRemixMedia.js */

import TextPhotoDefaults from "../enums/TextPhotoDefaults";
import FileHelper from "../helpers/FileHelper";
import ProcessImageForUpload from "../helpers/ProcessImageForUpload";
import RemixHelper from "../helpers/RemixHelper";
import PSO from "../services/PSO";

export const SendRemixMedia = async ({ al, un, remixMedia, rid }) => {
  let returnV = true;
  const eids = [];
  const totalMedia = remixMedia.length;

  // Inverting MEDIA array
  const localRemixMedia = (remixMedia) ? [...remixMedia].reverse() : [];

  for (let i = 0; i < localRemixMedia.length; i++) {
    const currentImage = localRemixMedia[i];

    if (currentImage && currentImage.type === 'mediapack') {
      try {
        const sendPhotoArgs = { al, un, rid, uptype: 1, upfn: currentImage.eid };
        const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
        if (response && response.element_id) { eids.push(response.element_id); }
      } catch (error) {
        console.error(error);
      }
    } else if (currentImage && currentImage.type === 'file') {
      const targetFile = await ProcessImageForUpload(
        currentImage.file,
        process.env.REACT_APP_PZ_EXIF_JS,
        process.env.REACT_APP_MIN_UPLOAD_PHOTO_WIDTH,
        process.env.REACT_APP_MIN_UPLOAD_PHOTO_HEIGHT,
        process.env.REACT_APP_MAX_UPLOAD_PHOTO_WIDTH,
        process.env.REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT,
        true
      );
      if (targetFile && targetFile !== undefined) {
        // const fileDataURI = currentImage.src;
        // const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
        try {
          const sendPhotoArgs = { al, un, rid, Filedata: targetFile, Filename: targetFile.name };
          const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
          if (response && response.element_id) { eids.push(response.element_id); }
        } catch (error) {
          console.error(error);
        }
      }
    } else if (currentImage && currentImage.type === 'blobfile') {
      const targetFile = currentImage.file;
      if (targetFile && targetFile !== undefined) {
        const fileBLOB = targetFile;
        try {
          const sendPhotoArgs = { al, un, rid, Filedata: fileBLOB, Filename: 'remixPhoto.jpg' };
          const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
          if (response && response.element_id) { eids.push(response.element_id); }
        } catch (error) {
          console.error(error);
        }
      }
    } else if (currentImage && currentImage.type === 'textphoto') {
      if (currentImage.layers && currentImage.layers.length > 0 && currentImage.layers[0] !== null) {
        const originalFileBLOB = FileHelper.dataURItoBlob(await RemixHelper.generateBasePhotoWithLayer(currentImage.layers));
        const renderedFileBLOB = FileHelper.dataURItoBlob(currentImage.src);

        const txts = [];
        if (currentImage.layers && currentImage.layers.length > 0) {
          currentImage.layers.forEach((item) => {
            if (item.type === 'text') {
              let x = item.x;
              let y = item.y;
              const h = item.h;
              const w = item.w;

              if (item.textAlign === 'center') {
                if (item.renderedW) {
                  x = x - (item.renderedW / 2);
                }
                if (item.renderedH) {
                  y = y - (item.renderedH / 2);
                }
              }

              x = x - TextPhotoDefaults.COMPATIBILITY_X_FACTOR;
              y = y - TextPhotoDefaults.COMPATIBILITY_Y_FACTOR;

              txts.push({
                t: RemixHelper.generateTextLayerBreakLine(item),
                c: encodeURIComponent(item.color),
                y: y,
                x: x,
                h: h,
                w: w,
                a: 0,
                s: item.fontSize / TextPhotoDefaults.SCALE_FACTOR,
                f: encodeURIComponent(item.font),
                app: 'web'
              });
            }
          });
        }

        try {
          const etxtjson = { txts: txts, isTxtPhoto: true };
          const sendPhotoArgs = {
            al, un, rid,
            Filedata: originalFileBLOB,
            Filename: 'remixPhoto.jpg', 
            etxtjson: JSON.stringify(etxtjson)
          }
          const resp = await PSO.sendPhotoToRemix(sendPhotoArgs);
          if (resp && resp.element_id) { eids.push(resp.element_id); }

          if (resp && resp.result === 'success' && resp.element_id) {
            const elementId = resp.element_id;

            const replacePhotoArgs = {
              al, un, rid,
              eid: elementId,
              etxtjson: JSON.stringify(etxtjson),
              Filedata: renderedFileBLOB,
              Filename: 'remixPhoto.jpg', 
            }
            await PSO.replacePhotoInRemix(replacePhotoArgs);

            // Changing foto animation to crop to FIT
            const cropToFixArgs = { al, un, etype: 1, eid: elementId, eaid: '1003' };
            await PSO.modifyElementGlobal(cropToFixArgs);
          }
        } catch (error) {
          console.error(error);
        }
      }
    } else if (currentImage && currentImage.type === 'unsplash') {
      const targetFile = currentImage;
      if (targetFile && targetFile !== undefined) {
        const fileDataURI = currentImage.src;
        const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
        try {
          const sendPhotoArgs = { al, un, rid, Filedata: fileBLOB, Filename: targetFile.name };
          const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
          if (response && response.element_id) { eids.push(response.element_id); }
        } catch (error) {
          console.error(error);
        }
      }
    } else if (currentImage && currentImage.type === 'video') {
      const targetFile = currentImage;
      if (targetFile && targetFile !== undefined) {
        const fileDataURI = currentImage.src;
        const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
        try {
          const sendVideoArgs = { al, un, rid, Filedata: fileBLOB, Filename: targetFile.file.name };
          const response = await PSO.sendVideoToRemix(sendVideoArgs);
          if (response && response.element_id) { eids.push(response.element_id); }
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  if (eids.length !== totalMedia) { returnV = false; }

  return { returnV, eids, totalMedia };
}
